module.exports = __webpack_public_path__ + "img/dialog_cart.825eea0f.svg";